(function ($, Global) {
    var ModalSimuIndependantComponent = function (model) {
		this.model = model;
	};

	ModalDevisComponent.prototype.initEvents = function () {
		this.subscribers();
	}

    ModalDevisComponent.prototype.subscribers = function () {
        $.Topic('modal-offre-independant').subscribe(function () {
            $('#modalSimuIndependant').modal('show');
        })
	}

    Global.ModalSimuIndependantComponent = ModalSimuIndependantComponent;
}(jQuery, window));